import React from 'react';
import clsx from 'clsx';
import FETabButtonProps from './props';
import style from './style.module.css';

export default React.forwardRef<HTMLButtonElement, FETabButtonProps>(
  ({ children, onClick, active, disabled = false, onChangeActive }, ref) => {
    React.useEffect(() => {
      onChangeActive && onChangeActive(active);
    }, [active, onChangeActive]);

    return (
      <button
        className={clsx(style.root, active && style.active)}
        disabled={disabled}
        onClick={(e) => {
          onClick(e);
          // e.preventDefault();
          // e.stopPropagation();
        }}
        ref={ref}
      >
        {children}
      </button>
    );
  },
);

export type { FETabButtonProps };
